import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    window.addEventListener('scroll', this.boundScrollHandler)

    // Initialization
    this.boundScrollHandler()
  }

  disconnect() {
    window.removeEventListener('scroll', this.boundScrollHandler)
  }

  scrollHandler() {
    this.handleStickyHeader()
    this.showOrHideBackToTopBtn()
    this.resolveActiveMenuItem()
  }

  get boundScrollHandler() {
    return this.scrollHandler.bind(this)
  }

  handleStickyHeader() {
    let sticky = 0
    const ud_header = document.querySelector('.ud-header')
    const logo = document.querySelectorAll('.header-logo')
    const isLanding = ud_header.dataset.landing

    window.scrollY > sticky
      ? ud_header.classList.add('sticky')
      : ud_header.classList.remove('sticky')

    const logoWhite = () => {
      logo[0].classList.remove('text-primary')
      logo[0].classList.add('text-white')
    }

    const logoPrimary = () => {
      logo[0].classList.remove('text-white')
      logo[0].classList.add('text-primary')
    }

    // Landing
    if (logo.length && isLanding === 'true') {
      if (ud_header.classList.contains('sticky')) {
        document.documentElement.classList.contains('dark')
          ? logoWhite()
          : logoPrimary()
      } else {
        logoWhite()
      }
    }

    // Other pages
    if (logo.length && isLanding === 'false') {
      document.documentElement.classList.contains('dark')
        ? logoWhite()
        : logoPrimary()
    }
  }

  showOrHideBackToTopBtn() {
    const backToTop = document.querySelector('.back-to-top')

    backToTop.style.display =
      document.body.scrollTop > 50 || document.documentElement.scrollTop > 50
        ? 'flex'
        : 'none'
  }

  smoothScrollIntoView(event) {
    event.preventDefault()
    const destinationEl = event.target.getAttribute('href')

    if (!!destinationEl)
      document.querySelector(destinationEl)?.scrollIntoView({ behavior: 'smooth', offsetTop: 1 - 60 })
  }

  resolveActiveMenuItem() {
    const sections = document.querySelectorAll('.ud-menu-scroll')
    const scrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

    for (let i = 0; i < sections.length; i++) {
      const currLink = sections[i]
      const val = currLink.getAttribute('href')
      const refElement = document.querySelector(val)
      const scrollTopMinus = scrollPos + 73

      if (
        refElement.offsetTop <= scrollTopMinus &&
        refElement.offsetTop + refElement.offsetHeight > scrollTopMinus
      ) {
        document.querySelector('.ud-menu-scroll').classList.remove('active')
        currLink.classList.add('active')
      } else {
        currLink.classList.remove('active')
      }
    }
  }

  scrollTop(event) {
    event.preventDefault()

    Math.easeInOutQuad = (t, b, c, d) => {
      t /= d / 2
      if (t < 1) return (c / 2) * t * t + b
      t--
      return (-c / 2) * (t * (t - 2) - 1) + b
    }

    const scrollTo = (element, to = 0, duration = 500) => {
      const start = element.scrollTop
      const change = to - start
      const increment = 20
      let currentTime = 0

      const animateScroll = () => {
        currentTime += increment
        const val = Math.easeInOutQuad(currentTime, start, change, duration)
        element.scrollTop = val
        if (currentTime < duration) setTimeout(animateScroll, increment)
      }

      animateScroll()
    }

    scrollTo(document.documentElement)
  }
}